import {
  MENU
} from './../../../constants';
import { createAction } from 'redux-actions';
import { menuState } from './../services';

export const changeMenuState = createAction(MENU,
  (state) => menuState(state)());
